<template>
  <div class="fixed inset-0 z-40 bg-black/30 flex items-center justify-center" @click.self="$emit('close')">
    <div class="bg-white rounded-lg border border-gray-200 w-[36rem] max-w-[95vw] flex flex-col">
      <div class="px-4 py-3 border-b border-gray-100 flex items-center justify-between shrink-0">
        <h3 class="text-sm font-semibold text-gray-900">Add data to this session</h3>
        <button class="text-gray-400 hover:text-gray-600" @click="$emit('close')">×</button>
      </div>
      <div class="p-4 space-y-3">
        <p class="text-xs text-gray-600">
          The file lands in this tenant's uploads area. Nothing is sent to the agent
          until you tell it what to do with the file.
        </p>
        <label
          class="block border border-dashed border-gray-200 rounded-lg px-4 py-8 text-center cursor-pointer hover:border-gray-400"
          :class="{ 'opacity-50 pointer-events-none': uploading }"
        >
          <span class="text-sm text-gray-800">{{ uploading ? 'Uploading…' : 'Choose a file' }}</span>
          <span class="block text-[11px] text-gray-600 mt-1">csv, xlsx, xls, xlsm, xlsb, zip, txt · pdf, docx, md, json</span>
          <input
            type="file"
            class="hidden"
            accept=".csv,.xlsx,.xls,.xlsm,.xlsb,.zip,.txt,.pdf,.docx,.md,.json"
            :disabled="uploading"
            @change="upload"
          />
        </label>
        <p v-if="error" class="text-xs text-red-dark">{{ error }}</p>
        <p v-if="note" class="text-xs text-amber-700">{{ note }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AgentUploadModal',
  emits: ['close', 'uploaded', 'failed'],
  props: { sessionId: { type: String, default: '' } },
  data() {
    return { uploading: false, error: '', note: '' };
  },
  methods: {
    async upload(event) {
      const file = event.target.files[0];
      event.target.value = '';
      if (!file) return;
      this.uploading = true;
      this.error = '';
      try {
        const { data: presigned } = await axios.post('/api/etl_module/upload/', {
          filename: file.name,
          content_type: file.type || 'application/octet-stream',
        });
        const put = await fetch(presigned.upload_url, {
          method: 'PUT',
          headers: { 'Content-Type': file.type || 'application/octet-stream' },
          body: file,
        });
        if (!put.ok) throw new Error(`S3 upload failed (${put.status})`);
        let frames = [];
        try {
          const { data: registered } = await axios.post('/api/impact_analytics/frames/from_upload/', {
            s3_key: presigned.s3_key, session: this.sessionId || '',
          });
          frames = registered.frames || [];
          if (registered.error) this.note = registered.error;
        } catch (err) {
          this.note = err?.response?.data?.error || 'The file was uploaded but could not be registered as a table.';
        }
        this.$emit('uploaded', { name: file.name, key: presigned.s3_key, frames });
        this.$emit('close');
      } catch (err) {
        this.error = (err && err.message) || 'Upload failed.';
        this.$emit('failed', { name: file.name, error: this.error });
      }
      this.uploading = false;
    },
  },
};
</script>
